import React from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";
import { formatOptions } from "../../../utils/helpers";
import { dataSecurityList, effectivenessList } from "../../../utils/types";

interface FitForPurposeEditProps {
  control: any;
  errors: any;
  watch: any;
  setValue: any;
}

const FitForPurposeEdit: React.FC<FitForPurposeEditProps> = ({
  control,
  errors,
  watch,
  setValue,
}) => {
  const dataSecurityOptions = formatOptions(dataSecurityList);
  const effectivenessOptions = formatOptions(effectivenessList);

  return (
    <div className="font-Inter max-w-2xl">
      <div className="space-y-6">
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Level of effectiveness for purpose
            <span className="text-red-500">*</span>
          </label>
          <Controller
            name="effectivenessPurposeLevel"
            control={control}
            render={({ field }) => (
              <Select
                options={effectivenessOptions}
                placeholder="Select Effectiveness Level..."
                onChange={(selected) => field.onChange(selected?.value || "")}
                value={
                  effectivenessOptions.find(
                    (opt) => opt.value === field.value
                  ) || null
                }
              />
            )}
          />
          {errors.effectivenessPurposeLevel && (
            <p className="text-red-500 text-xs mt-1">
              {errors.effectivenessPurposeLevel.message}
            </p>
          )}
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Data Security
            <span className="text-red-500">*</span>
          </label>
          <Controller
            name="dataSecurity"
            control={control}
            render={({ field }) => (
              <Select
                options={dataSecurityOptions}
                placeholder="Select Data Security Level..."
                onChange={(selected) => field.onChange(selected?.value || "")}
                value={
                  dataSecurityOptions.find(
                    (opt) => opt.value === field.value
                  ) || null
                }
              />
            )}
          />
          {errors.dataSecurity && (
            <p className="text-red-500 text-xs mt-1">
              {errors.dataSecurity.message}
            </p>
          )}
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Support and Training Needs
          </label>
          <Controller
            name="supportTainingNeeds"
            control={control}
            render={({ field }) => (
              <input
                type="text"
                {...field}
                className={`w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                  errors.supportTainingNeeds
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
                placeholder="Support and Training Needs"
              />
            )}
          />
          {errors.supportTainingNeeds && (
            <p className="text-red-500 text-xs mt-1">
              {errors.supportTainingNeeds.message}
            </p>
          )}
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Improvements required
          </label>
          <Controller
            name="improvementRequired"
            control={control}
            render={({ field }) => (
              <input
                type="text"
                {...field}
                className={`w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                  errors.improvementRequired
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
                placeholder="Improvements required"
              />
            )}
          />
          {errors.improvementRequired && (
            <p className="text-red-500 text-xs mt-1">
              {errors.improvementRequired.message}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default FitForPurposeEdit;
